import React from 'react';
import { Section } from './ui/Section';
import { BookOpen, Heart, MessageSquare, Shield } from 'lucide-react';
export function ProductSection() {
  return <Section background="warm" className="relative overflow-hidden" data-id="element-212">
      <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-213">
        <div className="order-2 md:order-1" data-id="element-214">
          <div className="inline-block px-3 py-1 rounded-full bg-orange-100 text-orange-800 font-semibold text-xs mb-4" data-id="element-215">
            Presentando el método
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-stone-900 mb-4" data-id="element-216">
            Puentes de Palabras
          </h2>
          <p className="text-base text-stone-700 mb-6 leading-relaxed" data-id="element-217">
            Un ebook práctico para hijos/as adultos (28–60) que quieren volver a
            comunicarse con sus padres mayores sin pelear, sin rogar y sin
            quedarse con culpa.
          </p>

          <div className="bg-white p-6 rounded-2xl shadow-sm border border-orange-100" data-id="element-218">
            <h3 className="text-lg font-bold text-stone-900 mb-3 flex items-center gap-2" data-id="element-219">
              El corazón del método:{' '}
              <span className="text-orange-700" data-id="element-220">El Diccionario Familiar</span>
            </h3>
            <p className="text-stone-600 mb-4 text-sm" data-id="element-221">
              Un sistema simple de co-creación para definir:
            </p>
            <ul className="space-y-3" data-id="element-222">
              {[{
              icon: MessageSquare,
              text: 'Qué palabras apagan (y cuáles abren)'
            }, {
              icon: Shield,
              text: 'Qué frases usar cuando sube la tensión'
            }, {
              icon: Heart,
              text: 'Qué señales no verbales bajan el choque'
            }, {
              icon: BookOpen,
              text: 'Qué rutinas sostienen el vínculo'
            }].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-223">
                  <div className="bg-orange-50 p-1.5 rounded-lg text-orange-700" data-id="element-224">
                    <item.icon size={16} data-id="element-225" />
                  </div>
                  <span className="text-stone-800 font-medium text-sm" data-id="element-226">
                    {item.text}
                  </span>
                </li>)}
            </ul>
          </div>

          <p className="mt-4 text-center md:text-left text-stone-500 italic text-sm" data-id="element-227">
            No es terapia. Es un protocolo familiar.
          </p>
        </div>

        <div className="order-1 md:order-2 flex justify-center" data-id="element-228">
          <div className="relative w-full max-w-sm" data-id="element-229">
            <div className="absolute inset-0 bg-stone-900/5 rounded-2xl transform translate-x-4 translate-y-4" data-id="element-230" />
            <img src="https://cdn.magicpatterns.com/uploads/jDTfNsZx964hmUHsFxtcz5/ChatGPT_Image_26_ene_2026,_18_35_22_ebook_puestes_de_palabras_2.png" alt="Puentes de Palabras Cover" className="relative rounded-xl shadow-2xl w-full object-cover" data-id="element-231" />
          </div>
        </div>
      </div>
    </Section>;
}